<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
  >
    <template slot="select">
      <FormItem>
        <Select
          v-model="searchFrom.agent_id"
          filterable
          clearable
          placeholder="Please Select Agrnt"
        >
          <Option v-for="item in objAgent" :value="item.id" :key="item.id">{{
            item.agent_name
          }}</Option>
        </Select>
      </FormItem>
    </template>
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick(0, 'add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>
    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="130"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <FormItem :label="$t('paramsType')" prop="type">
            <Select
              v-model="dataDetails.type"
              filterable
              :disabled="disabled"
              placeholder="Please Select Type"
            >
              <Option v-for="item in typeList" :value="item" :key="item">{{
                item
              }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="$t('paramsUrl')" prop="url">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.url"
              placeholder="Please Enter Url"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('paramsAccount')" prop="params_account">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.params_account"
              placeholder="Please Enter Account"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('paramsPwd')" prop="params_password">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.params_password"
              placeholder="Please Enter Pwd"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('paramsSet')" prop="params_secret">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.params_secret"
              placeholder="Please Enter Secret"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('paramsAgent')" prop="agent_id">
            <Select
              v-model="dataDetails.agent_id"
              filterable
              clearable
              :disabled="disabled"
              placeholder="Please Select Agrnt"
            >
              <Option
                v-for="item in objAgent"
                :value="item.id"
                :key="item.id"
                >{{ item.agent_name }}</Option
              >
            </Select>
          </FormItem>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import { add, getParams, getDetails, update, del } from "@/api/tracker/params";
// import basic from "@/utils/basic";
// import nodata from "@/utils/nodata";
import common from "_c/common-body";
import bosMes from "@/utils/message";

export default {
  name: "trackerparams",
  components: {
    common,
  },
  data() {
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        type: [
          {
            required: true,
            message: "agent_name cannot be empty",
            trigger: "change",
          },
        ],
        url: [
          {
            required: true,
            message: "agent_types cannot be empty",
            trigger: "blur",
          },
        ],
        params_account: [
          {
            required: true,
            message: "params_account cannot be empty",
            trigger: "blur",
          },
        ],
        params_password: [
          {
            required: true,
            message: "params_password cannot be empty",
            trigger: "blur",
          },
        ],
        params_secret: [
          {
            required: true,
            message: "params_secret cannot be empty",
            trigger: "blur",
          },
        ],
        agent_id: [
          {
            required: true,
            type: "number",
            message: "agent_id cannot be empty",
            trigger: "change",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      typeList: ["CREATE", "LABEL", "CLEARANCE", "TRACK"],
      objAgent: {},
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("paramsType"),
        key: "type",
        align: "center",
        tooltip: true,
      });
      columns.push({
        title: this.$t("paramsUrl"),
        key: "url",
        align: "center",
        tooltip: true,
      });
      columns.push({
        title: this.$t("paramsAccount"),
        key: "params_account",
        align: "center",
      });
      columns.push({
        title: this.$t("paramsPwd"),
        key: "params_password",
        align: "center",
      });
      columns.push({
        title: this.$t("paramsSet"),
        key: "params_secret",
        align: "center",
      });
      columns.push({
        title: this.$t("paramsAgent"),
        key: "agent_name",
        align: "center",
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        minWidth: 150,
      });
      return columns;
    },
  },
  watch: {
    dataDetails: {
      handler: function (nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.objAgent = basic.objAgent();
    this.getList();
  },
  methods: {
    changeBindModal(val) {
      if (!val) {
        this.isshowModal = false;
      } else {
        if (this.crudText === "delete") {
          this.deleteList(this.delId);
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.crudText === "add") {
            this.addList();
          } else {
            this.updateList();
          }
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    SearchSubmit() {
      this.getList(this.searchFrom);
    },
    // 展示页码条数
    pageSizeChange(size) {
      this.searchFrom.pageSize = size;
      this.getList();
    },
    // 页码点击切换
    pageChange(page) {
      this.searchFrom.page = page;
      this.getList();
    },
    crudClick(item, text) {
      // this.objAgent = basic.objAgent();

      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
          }
          this.getDetailsList(item.id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then((res) => {
          delete res.data.payload.country;
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList() {
      this.loading = true;
      getParams(this.searchFrom)
        .then((res) => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows
          // .map((item) => {
          //   let agent = nodata.noData(basic.objAgent(), item.agent_id, "agent");
          //   item.agent_name = agent.name;
          //   return item;
          // });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addList() {
      add(this.dataDetails).then((res) => {
        bosMes.alertMes(res, this);
      });
    },
    updateList() {
      // delete this.dataDetails.country
      update(this.dataDetails).then((res) => {
        bosMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then((res) => {
        bosMes.alertMes(res, this);
      });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
</style>
